import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { configService, RootState, getAppsFromMask, APPS_NAME } from '@umanforge/common';

import { NavigationService } from '../services/navigation.service';

import { APPS_INFOS } from 'constants/app.constants';

import { HomeTopBar } from '../components/menu/home_top_bar.component';
import { HomeLeftBar } from 'components/menu/home_left_bar.component';
import { AppButton } from 'components/app_button.component';
import { SearchComponent } from 'components/search/search.component';
import { UmanforgeLogo } from 'components/icons/logos/umanforge_logo.component';


export function HomeView() {
  const { t } = useTranslation();
  const token = useSelector( ( state: RootState ) => { return state.token.value; } );
  const dispatch = useDispatch();

  const user = useSelector( ( state: RootState ) => { return state.user.value; } );
  const [ apps, setApps ] = useState<{ id: APPS_NAME, name: string, url: string, color?: string, icon: JSX.Element, disabled?: boolean }[]>( [] );

  useEffect( () => {
    initApps();
  }, [ user ] );

  const initApps = async () => {
    const baseApps = [
      { id: APPS_NAME.FLASHMEETING, ...APPS_INFOS.Flashmeeting, url: await configService.getFlashmeetingUrl() },
      { id: APPS_NAME.KAMISHIBAI, ...APPS_INFOS.Kamishibai, url: await configService.getKamishibaiUrl() },
      { id: APPS_NAME.RESOLUTION, ...APPS_INFOS.Resolution, url: await configService.getResolutionUrl() },
      { id: APPS_NAME.PLANITEAM, ...APPS_INFOS.Planiteam, url: await configService.getPlaniteamUrl() }
    ];

    const allowed = getAppsFromMask( Number( user?.appAccess ?? 15 ) );
    // keep all apps but mark as disabled if not allowed
    setApps( baseApps.map( a => {return { ...a, disabled: !allowed.includes( a.id ) };} ) );
  };

  /*---------------------------------- Front ----------------------------------*/
  return (
    <>
      <HomeLeftBar items={ NavigationService.getNavBarItems( token, dispatch ) } needConfirmation={ false } />
      <div>
        <HomeTopBar title={ t( 'Home' ) } needConfirmationToNav={ false }/>

        <div className='flex flex-col w-full h-full gap-4 text-center justify-center items-center rounded-xl my-12'>
          <UmanforgeLogo className='w-[200px] h-fit fill-orange-base'/>
          <div className='flex flex-col'>
            <span className='font-umanforge text-6xl text-neutral-900'> { t( 'common:apps.umanforge' ) } </span>
            <span className='font-umanforge text-2xl text-neutral-600'> { t( 'common:industrial_operations_suite' ) } </span>
          </div>
        </div>
        <div className='flex flex-col gap-16'>
          {
            apps.length > 0 ?
              <div>
                <div className='flex h-full w-full'>
                  <div className='flex flex-1 flex-wrap lg:flex-row w-full h-fit px-6 justify-center items-center'>
                    {
                      apps.map( app => {
                        return (
                          <AppButton
                            key={  app.name }
                            name={ t( `common:apps.${ app.name.toLowerCase() }` ) }
                            icon={ app.icon }
                            color={ app.color }
                            url={ app.url }
                            disabled={ app.disabled }
                          />
                        );
                      } )
                    }
                  </div>
                </div>
              </div>
              :
              null
          }
          <div className="flex justify-center">
            <SearchComponent/>
          </div>
        </div>
      </div>
    </>
  );

}